import { useState, useEffect } from 'react';

interface DataLoaderState<T> {
  data: T | null;
  loading: boolean;
  error: string | null;
}

export function useDataLoader<T>(
  loader: () => Promise<T>,
  dependencies: any[] = []
): DataLoaderState<T> {
  const [state, setState] = useState<DataLoaderState<T>>({
    data: null,
    loading: true,
    error: null
  });

  useEffect(() => {
    let isCancelled = false;

    const loadData = async () => {
      setState(prev => ({ ...prev, loading: true, error: null }));
      
      try {
        const result = await loader();
        
        if (!isCancelled) {
          setState({
            data: result,
            loading: false,
            error: null
          });
        }
      } catch (error) {
        console.error('Error loading data:', error);
        if (!isCancelled) {
          setState({
            data: null,
            loading: false,
            error: error instanceof Error ? error.message : 'Failed to load data'
          });
        }
      }
    };

    loadData();

    return () => {
      isCancelled = true;
    };
  }, dependencies);

  return state;
}
